<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            registrationData: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapState('components',[
                'componentTypesMapping'
            ]),
            componentNameForType () {
                return this.envNamePrefix + this.findComponentType + "Component";
            },
            findComponentType () {
                return this.registrationData.componentType && this.componentTypesMapping[this.registrationData.componentType] ? this.componentTypesMapping[this.registrationData.componentType] : "";
            },
        }
    }
</script>
